import React, { createContext, useCallback, useContext, useEffect, useId, useMemo, useState } from "react";
const HelpContext = createContext({ screen: null, publish: () => {} });
export function ScreenHelpProvider({ children }) {
  const [entries, setEntries] = useState({});
  const publish = useCallback((id, value) => setEntries(previous => {
    const next = { ...previous };
    if (value) next[id] = value; else delete next[id];
    return next;
  }), []);
  const screen = Object.values(entries).sort((a, b) => b.priority - a.priority)[0]?.help || null;
  const context = useMemo(() => ({ screen, publish }), [screen, publish]);
  return <HelpContext.Provider value={context}>{children}</HelpContext.Provider>;
}
export function useScreenHelp(help, priority = 20) {
  const id = useId(), { publish } = useContext(HelpContext);
  const encoded = JSON.stringify(help);
  useEffect(() => {
    const parsed = JSON.parse(encoded || "null");
    if (parsed) publish(id, { help: parsed, priority });
    return () => publish(id, null);
  }, [id, publish, encoded, priority]);
}
export const useDisplayedScreenHelp = () => useContext(HelpContext).screen;
